export default (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center'
  },
  words: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  body: {
    marginTop: '2rem'
  }
})
